import { useCallback } from 'react';
import { useSetPlayerTags } from 'server';
import { useGetErrorMessage } from 'js/hooks/server/hooks';
import { FORM_ERROR, type FormApi } from 'final-form';
import { useShowNotification } from 'js/hooks/useShowNotification';

import * as Types from '../types';
import * as server from 'js/components/main/PromoCode/server';

export const useOnSubmit = () => {
    const getErrorMessage = useGetErrorMessage();
    const showNotification = useShowNotification();
    const setPlayerTags = useSetPlayerTags();

    return useCallback(
        async (
            values: Types.IPromoCodeFormValues,
            form: FormApi<Types.IPromoCodeFormValues>
        ): Promise<{ [FORM_ERROR]: string } | undefined> => {

            if (!values?.promoCode) {
                values.errorValid = true;
                return;
            }

            values.errorValid = false;

            const promoTag = [
                {
                    name: 'Portal/Custom_Promocode',
                    type: 'text',
                    value: values.promoCode,
                    expirationDate: ''
                }
            ];

            const messages = {
                1: 'playtech.mobile.system.promocode.atLeastOneBonusGiven',
                2: 'playtech.mobile.system.promocode.info.tryWithDeposit',
                3: 'playtech.mobile.system.promocode.info.noBonus'
            };

            try {
                await setPlayerTags({ tags: promoTag });
            } catch (error) {
                return {
                    [FORM_ERROR]: 'playtech.mobile.system.promocode.setTag.error'
                };
            }

            try {
                const resPromoCode = await server.submitPromoCode(values.promoCode);
                const result = resPromoCode?.data?.result;
                const messageTk = messages[result];

                const variant = result === 1 || result === 2 ? 'success' : 'info';

                messageTk && showNotification(messageTk, { variant });

                // At least one bonus was given
                if (result === 1) {
                    form.restart();
                }
            } catch (error: unknown) {
                return {
                    [FORM_ERROR]: getErrorMessage(error)
                };
            }
        },
        [getErrorMessage, setPlayerTags, showNotification]
    );
};
